import React, { useMemo } from 'react';

import
    CommonMobileHeader, {
    ICommonActions,
} from '~/src/features/_layout/Header/mobile/components/CommonMobileHeader';
import BurgerView from '~/src/features/_layout/Header/mobile/components/ConnectionAndLoginActions/BurgerView';
import MainView from '~/src/features/_layout/Header/mobile/components/ConnectionAndLoginActions/MainView';
import { IUnauthHeaderProps } from '~/src/features/_layout/Header/types';

const UnauthMobileHeader = ({
    onBecomeClientHandler,
    referrerPath,
    ...props
}: IUnauthHeaderProps): JSX.Element => {
    const CommonActions: ICommonActions = useMemo(() => {
        const Actions =  <MainView onOpenBecomeClientPopup={onBecomeClientHandler}/>;

        const ActionsInBurger = (_props: { closeHandler?: () => void }): JSX.Element => {
            return <BurgerView
                onOpenBecomeClientPopup={onBecomeClientHandler}
                referrerPath={referrerPath}
                {..._props}
            />;
        };

        return { Actions, ActionsInBurger };
    }, [onBecomeClientHandler, referrerPath]);

    return (
        <CommonMobileHeader
            {...props}
            CommonActions={CommonActions}
            isAuth={false}
        />
    );
};

export default UnauthMobileHeader;
